import React, { useEffect, useContext, useState, useCallback } from "react";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import {
  getTurnosService,
  createTurnosService,
} from "../../utils/TurnoService";
// Here we import all things for the React-Scheduler
import {
  Inject,
  ScheduleComponent,
  Day,
  Week,
  WorkWeek,
  Month,
  TimelineViews,
  Resize,
  Agenda,
  DragAndDrop,
  ViewsDirective,
  ViewDirective,
} from "@syncfusion/ej2-react-schedule";

function Scheduler() {
  const [data, setData] = useState();
  const [eventoSinSentido, setEventoSinSentido] = useState(0);
  const { authTokens } = useContext(AuthContext);


  //Get the 'Guardar Cambios' button from Dom
  const saveButton = document.getElementById("btn-fixed-save");

  // When the user scrolls down 60px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction();
  };

  // This function make visible the 'GuardarCambios' button when scrolling
  function scrollFunction() {
    if (
      document.body.scrollTop > 60 ||
      document.documentElement.scrollTop > 60
    ) {
      saveButton.style.display = "block";
    } else {
      saveButton.style.display = "none";
    }
  }

  const saveHandler = () => {
    setEventoSinSentido((prev) => prev + 1);

    const body = data;
    createTurnos(body);
  };

  // Pedido de todos los turnos al servicio 'getTurnosService.
  const getTurnos = useCallback(async () => {
    const turnos = await getTurnosService(authTokens);
    setData(turnos ?? []);
  }, [authTokens]);

  // Enviar los turnos guardados al backend mediante el servicio 'createTurnosService.
  const createTurnos = useCallback(async (turnos) => {
    createTurnosService(turnos, authTokens).then((response) => {});
  });

  useEffect(() => {
    getTurnos();
  }, []);

  return (
    <>
      <div>
        <div className="d-flex justify-content-center">
          <button
            type="button"
            className="btn btn-success"
            onClick={() => saveHandler()}
            id="btn-fixed-save"
          >
             ¡ No olvide guardar cambios !
          </button>
        </div>

        <div className="row">
          <div className="mt-4  d-flex justify-content-start">
            <h4>Turnos</h4>
          </div>
        </div>
        <div className="d-flex justify-content-between my-3">
          <button
            className="btn btn-success btn-sm"
            onClick={() => saveHandler()}
          >
            {" "}
            Guardar Cambios
          </button>

          <Link className="btn btn-info btn-sm" to="/nuevavisita">
            Registrar visita
          </Link>
        </div>
        <ScheduleComponent
          allowDragAndDrop={true}
          currentView="Day"
          eventSettings={{
            dataSource: data,
            fields: {
              id: "Id",
              subject: { name: "Subject", title: "Event Name" },
              description: { name: "Description", title: "Event Description" },
              startTime: { name: "StartTime", title: "Start Duration" },
              endTime: { name: "EndTime", title: "End Duration" },
            },
          }}
          firstDayOfWeek={2}
          startHour="07:00"
          endHour="21:00"
        >
          <ViewsDirective>
            <ViewDirective option="Day" displayName="Dia" />
            <ViewDirective option="Week" displayName="Semana" />
            <ViewDirective option="Month" displayName="Mes" />
          </ViewsDirective>
          <Inject
            services={[
              Day,
              Week,
              WorkWeek,
              Month,
              TimelineViews,
              Resize,
              Agenda,
              DragAndDrop,
            ]}
          />
        </ScheduleComponent>
      </div>

      {/* 
        <div>
            <span> {JSON.stringify(data, 0, 10)}</span>
        </div>
      */}
    </>
  );
}

export default Scheduler;
